
import { ACTION_GET_CASHOUT_LIST, ACTION_GET_CASHOUT_LIST_ERROR, ACTION_GET_CASHOUT_LIST_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getCashoutListsRequest = (access_token, appInfo, url) => ({
    type: ACTION_GET_CASHOUT_LIST,
    payload: {
        access_token,
        appInfo,
        url
    }
})

export const getCashoutListsSuccess = data => ({
    type: ACTION_GET_CASHOUT_LIST_SUCCESS,
    payload: {
        data
    }
})


export const getCashoutListsError = (msg) => ({
    type: ACTION_GET_CASHOUT_LIST_ERROR,
    payload: {
        msg
    }
})

export const getCashoutLists = (access_token, appInfo, url) => {
    return dispatch => {
        dispatch(getCashoutListsRequest(access_token, appInfo, url))
        api.getCashoutLists(access_token, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getCashoutListsError("error"));
                    return
                }

                const {lists} = data
                dispatch(getCashoutListsSuccess(lists));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getCashoutListsError("system error"))
            });
    }
}